module.exports = __webpack_public_path__ + "static/media/fr_welcome.ec20ec59.png";